export const altText = (obj, key, localeCode, fallbackAlt) => {
  let lang = 'en';
  if (localeCode.includes('es')) {
    lang = 'es';
  }

  if (obj[`${key}_alt_${lang}`]) {
    return obj[`${key}_alt_${lang}`];
  }

  return fallbackAlt;
};
